<template>
  <div class="h-full">
    <router-view :roles="roles" :organizations="organizations"></router-view>
  </div>
</template>

<script>
import { getOrganizationList } from "@/entities/organization";
import { getRoleList } from "@/entities/role";

export default {
  name: "UsersIndex",
  data() {
    return {
      organizations: null,
      roles: null,
    };
  },
  created() {
    this.getOrganizationList();
    this.getRoleList();
  },
  methods: {
    async getOrganizationList() {
      let params = {};
      let data = await getOrganizationList(params);
      if (data?.success) {
        if (data?.payload?.length > 0) {
          this.organizations = data.payload;
        }
      }
    },
    async getRoleList() {
      let params = {};
      let data = await getRoleList(params);
      if (data?.success) {
        if (data?.payload?.items?.length) {
          this.roles = data.payload.items;
        }
      }
    },
  },
};
</script>

<style scoped></style>
